"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _popRights = _interopRequireDefault(require("../../components/equityPopup/popRights.vue"));
var _PurchaseDialog = _interopRequireDefault(require("../../components/equityPopup/PurchaseDialog.vue"));
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _carList = _interopRequireDefault(require("../../components/trade/car-list.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _askPush = _interopRequireDefault(require("../../components/trade/ask-push.vue"));
var _api = _interopRequireWildcard(require("../../api/api"));
var _util = _interopRequireDefault(require("../../assets/static/js/utils/util.js"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime");
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = {
  name: 'cardetail',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    carList: _carList.default,
    askPush: _askPush.default,
    footNav: _footNav.default,
    PurchaseDialog: _PurchaseDialog.default,
    popRights: _popRights.default
  },
  data: function data() {
    return {
      userId: '',
      vsid: '',
      showPush: false,
      showPhone: false,
      joinedStart: '',
      joinedEnd: '',
      detailData: {},
      recData: [],
      rightAdverData: [],
      sortConfig: {
        sortFlag: false
      },
      shareConfig: {
        url: '',
        title: '有【车】找货',
        image: 'http://www.weihuabiaoju.com/mp/images/wximg/logo-center.jpg',
        sites: ['qq', 'wechat', 'weibo'],
        wechatQrcodeTitle: '微信扫一扫',
        wechatQrcodeHelper: '<p>请用微信扫码分享</p>'
      },
      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }],
      dialogVisible: false,
      // 控制弹窗套餐显示状态
      popVisible: false,
      //权益识别是否购买弹窗
      poprightstext: '',
      //权益内容
      poprightsnewtext: '' //权益新用户
    };
  },
  created: function created() {
    // session替换成cookie
    var userInfo = (0, _cookie.getCookie)("user") ? JSON.parse((0, _cookie.getCookie)("user")) : '';
    // var userInfo = JSON.parse(window.sessionStorage.getItem("user"))
    this.userId = userInfo ? userInfo.usid : '';
    this.vsid = this.$route.query.vsid;
    this.loadDetailData();
    this.loadRecData();
    this.loadAdvertiseData();
    this.shareConfig.url = this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=3&id=' + this.vsid + '&userId=' + this.userId;
  },
  methods: {
    formatDate: _relativeTime.formatDate,
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    },
    //获取货源详情
    loadDetailData: function () {
      var _loadDetailData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, loadInstance, _yield$Api$apiGetCars, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context.next = 4;
              return _api.default.apiGetCarsDetailData({
                vsid: that.vsid
              });
            case 4:
              _yield$Api$apiGetCars = _context.sent;
              data = _yield$Api$apiGetCars.data;
              that.detailData = data.proData;
              loadInstance.close();
              that.joinedStart = _util.default.joinCityAndDistrict(data.proData.orginProvince, data.proData.orginCity, '');
              that.joinedEnd = _util.default.joinCityAndDistrict(data.proData.destinationProvince, data.proData.destinationCity, '');
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDetailData() {
        return _loadDetailData.apply(this, arguments);
      }
      return loadDetailData;
    }(),
    //获取推荐货源
    loadRecData: function () {
      var _loadRecData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$Api$apiGetRecC, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return _api.default.apiGetRecCarsByvsisData({
                vsid: that.vsid
              });
            case 3:
              _yield$Api$apiGetRecC = _context2.sent;
              data = _yield$Api$apiGetRecC.data;
              that.recData = data.proData.splice(0, 3);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadRecData() {
        return _loadRecData.apply(this, arguments);
      }
      return loadRecData;
    }(),
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, _yield$Api$apiGetAdve, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              _context3.next = 3;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_VS_DETAIL',
                userId: that.userId ? that.userId : ''
              });
            case 3:
              _yield$Api$apiGetAdve = _context3.sent;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    // 立即报价
    clickToAsk: function clickToAsk() {
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      var userToken = (0, _cookie.getCookie)('token');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage || !userToken) {
        this.$root.loginscene = 'VS_DETAIL'; //注册登录场景
        this.$root.loginsceneid = this.vsid;
        this.$root.dialogFormVisible = true;
      } else {
        this.showPush = true;
      }
    },
    // 拨打电话（权益校验）
    clickToCall: function () {
      var _clickToCall = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, param, jsonParam, _yield$apigetrightsch, data, _data$proData, bought, valid;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              param = {
                "fun": "rightscheck",
                "version": "1",
                "param": {
                  "rightsCode": 'RIGHTS_MERCHANT_PHONE',
                  "keyOne": 'merchant',
                  "keyTwo": that.$route.query.vsid,
                  "keyThree": '',
                  "version": 'v2'
                }
              };
              jsonParam = {
                jsonParamete: JSON.stringify(param)
              };
              _context4.next = 5;
              return (0, _api.apigetrightscheck)(jsonParam);
            case 5:
              _yield$apigetrightsch = _context4.sent;
              data = _yield$apigetrightsch.data;
              if (data.proCode === 200) {
                _data$proData = data.proData, bought = _data$proData.bought, valid = _data$proData.valid; // // 公共的 confirm 弹窗处理函数
                // const showConfirmDialog = (message, title = '温馨提示') => {
                //     this.$confirm(message, title, {
                //         confirmButtonText: '去购买',
                //         cancelButtonText: '取消',
                //     })
                //         .then(() => {
                //             this.openDialog()
                //             this.$message({ type: 'success', message: '去购买成功!' });
                //         })
                //         .catch(() => {
                //             this.$message({ type: 'info', message: '已取消' });
                //         });
                // };
                if (bought && !valid) {
                  // 已购买但已过期
                  this.popVisible = true;
                  this.poprightstext = '您当前购买的权益已过期，请重新购买';
                } else if (!bought && !valid) {
                  // 未购买且未生效
                  this.popVisible = true;
                  this.poprightsnewtext = "\n                    \u7531\u4E8E\u8FD1\u671F\u5E73\u53F0\u7528\u6237\u9891\u7E41\u53CD\u9988\u88AB\u9A9A\u6270\uFF0C\u4E3A\u4E86\u66F4\u9AD8\u6548\u7684\u5BF9\u63A5\u9700\u6C42\uFF0C\u53C2\u8003\u7528\u6237\u5EFA\u8BAE\uFF0C\n                    \u5E73\u53F0\u5C06\u91C7\u7528\u4ED8\u8D39\u8054\u7CFB\u7684\u65B9\u5F0F\uFF0C\u4EE5\u671F\u51CF\u5C11\u65E0\u6548\u6C9F\u901A\uFF0C\u907F\u514D\u8FC7\u5EA6\u9A9A\u6270\u3002\n                    \u540C\u65F6\u63D0\u9AD8\u4FE1\u606F\u6838\u5B9E\u529B\u5EA6\uFF0C\u4E3A\u5927\u5BB6\u63D0\u4F9B\u66F4\u597D\u670D\u52A1\u3002\u8FD8\u8BF7\u5927\u5BB6\u7406\u89E3\u548C\u652F\u6301\u3002";
                }
              }

              // session替换成cookie
              // let userStorage = getCookie('user')
              // // let userStorage = window.sessionStorage.getItem('user')
              // if (!userStorage) {
              // 	this.$root.loginscene = 'VS_DETAIL' //注册登录场景
              // 	this.$root.loginsceneid = this.vsid
              // 	this.$root.dialogFormVisible = true
              // } else {
              // this.showPhone = true
              // }
              //  console.log('showPhone:',this.showPhone)
              console.log('电话联系+++++++:', this.showPhone, data);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function clickToCall() {
        return _clickToCall.apply(this, arguments);
      }
      return clickToCall;
    }(),
    //***************** 查询套餐权益********************// 
    handleConfirm: function handleConfirm() {
      console.log("用户确认购买");
      this.dialogVisible = false; // 关闭弹窗
    },
    handleCancel: function handleCancel() {
      console.log("用户取消操作");
      this.dialogVisible = false; // 关闭弹窗
    },
    //***************** 查询购买权益********************// 
    popConfirm: function popConfirm() {
      console.log("用户确认购买");
      this.dialogVisible = true;
    },
    popCancel: function popCancel() {
      console.log("用户取消操作");
      this.dialogVisible = false; // 关闭弹窗
    }
  }
};